import styles from './index.module.scss';
import { Switch, Route, Link } from 'react-router-dom';
import { Footer } from '@burna/monster-design-system';
import Login from 'components/login';
import Register from 'components/register';
import ForgotPassword from 'components/forgot-password';

function Auth() {
  return (
    <div className={styles.page}>
      <div className={styles.wrapper}>
        <Link className={styles.logo} to="/">
          <div className={styles.logoIcon} />
        </Link>
        <div className={styles.innerWrapper}>
          <Link className={styles.logoMobile} to="/" />
          <Switch>
            <Route path="/login">
              <Login />
            </Route>
            <Route path="/register">
              <Register />
            </Route>
            <Route path="/forgot-password">
              <ForgotPassword />
            </Route>
          </Switch>
        </div>
        <Footer className={styles.footer}>
          <Footer.Start>
            <Footer.Text>
              Powered by <strong>Monster</strong>
            </Footer.Text>
          </Footer.Start>
          <Footer.End>
            <Footer.Link href="//burna.ir">About Us</Footer.Link>
          </Footer.End>
        </Footer>
      </div>
      <div className={styles.bg} />
    </div>
  );
}

export default Auth;
